import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Radio, RadioGroup, FormControlLabel, FormControl, FormLabel,
} from '@material-ui/core';
import * as utilFunctions from '../../utils/Functions';
import { CraverRadioStyle } from '../../css/style';

const styles = CraverRadioStyle();

export default class CraverRadio extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      selectedBoolean: props.data || 'false',
    };
  }

  componentDidMount() {
    this.props.onChange(this.state.selectedBoolean.toString() === 'true');
  }

  onChangeBoolean = (event) => {
    this.setState({ selectedBoolean: event });
    this.props.onChange(event.toString() === 'true');
  }

  getValue = () => {
    const { data, resourceName, field } = this.props;
    // For CollapsibleItems in Edit Product page
    if (resourceName === 'products' && field.key === 'isDefault') {
      if (data === undefined || data === null) return 'false';
      return data.toString();
    }
    return this.state.selectedBoolean.toString();
  }

  render() {
    const {
      disabled, hidepadding, fieldTitle, width,
    } = this.props;
    const isMobileAndMandatory = utilFunctions.isDeviceView('sm', width) && fieldTitle === 'Mandatory';
    const craverRadioMobile = isMobileAndMandatory ? styles.craverRadioMobile : null;
    const formControlLabelMobile = isMobileAndMandatory ? styles.formControlLabelMobile : null;
    return (
      <FormControl component="fieldset">
        <FormLabel component="legend">{this.props.label}</FormLabel>
        <RadioGroup
          name="default_setting"
          value={this.getValue()}
          onChange={(event) => { this.onChangeBoolean(event.target.value); }}
          style={hidepadding ? styles.CraverRadioStyleNoPadding : styles.CraverRadioStyle}
        >
          <FormControlLabel style={formControlLabelMobile} value="true" control={<Radio style={craverRadioMobile} color="primary" />} label="Yes" disabled={disabled} />
          <FormControlLabel style={formControlLabelMobile} value="false" control={<Radio style={craverRadioMobile} color="primary" />} label="No" disabled={disabled} />
        </RadioGroup>
      </FormControl>
    );
  }
}
